// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1CrHX","calendarButtons":"ClockData_calendarButtons__2q0dV"};